import React, { useState } from 'react';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleBlogClick = (e) => {
    e.preventDefault();
    closeMenu();
    alert("Blog coming soon! I'll be sharing insights about protein design, research, and biotechnology.");
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <button 
          className={`hamburger ${isOpen ? 'hamburger-open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className={`navbar-links ${isOpen ? 'navbar-links-open' : ''}`}>
          <a href="#home" onClick={closeMenu}>Home</a>
          <a href="#research" onClick={closeMenu}>Research</a>
          <a href="#publications" onClick={closeMenu}>Publications</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
          <a href="#" onClick={handleBlogClick}>Blog</a>
          {/* Original blog link: https://blog.austinseaman.com */}
        </div>
      </div>
    </nav>
  );
}
